function initDealBanners() {
  const banners = document.querySelectorAll('.deal-banner');
  if (!banners.length) return;

  banners.forEach((banner) => {
    const max = Number(banner.dataset.max);
    const min = Number(banner.dataset.min);

    if (!Number.isFinite(max) || !Number.isFinite(min) || max <= min) {
      console.warn('[deal-banner] invalid max/min, skip', { max, min });
      return;
    }

    let current = max;
    let prevValue = null;

    const counterEl = banner.querySelector('.deal-banner__left');
    const barFill = banner.querySelector('.deal-banner__bar-fill');

    function updateUI() {
      if (counterEl) {
        if (prevValue !== null && current !== prevValue) {
          counterEl.classList.add('deal-banner__left--changed');
          setTimeout(() => {
            counterEl.classList.remove('deal-banner__left--changed');
          }, 250);
        }

        counterEl.textContent = current;
        prevValue = current;
      }

      let percentLeft = (current / max) * 100;
      percentLeft = Math.max(0, Math.min(100, Math.round(percentLeft)));

      const percentSold = 100 - percentLeft;
      if (barFill) {
        barFill.style.width = percentSold + '%';
      }
    }

    function tick() {
      if (current <= min) {
        return;
      }

      const diff = Math.floor(Math.random() * 2) + 1;
      current = Math.max(min, current - diff);

      updateUI();

      if (current <= min) return;

      const delay = 10000 + Math.random() * 3000;
      setTimeout(tick, delay);
    }

    updateUI();
    const firstDelay = 3000 + Math.random() * 3000;
    setTimeout(tick, firstDelay);
  });
}

document.addEventListener('DOMContentLoaded', initDealBanners);
